module.exports = __webpack_public_path__ + "img/smart-park.9a8f4c04.jpg";